export default "__VITE_ASSET__8XSTOabu__"